import { C, fmt } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Fade } from '../ui/Fade'

const GALS = [
  {
    name: 'Частный дом · Медеу', city: 'Алматы', tag: 'ЧАСТНЫЙ ДОМ', span: 2,
    len: 10, wid: 5, dep: 1.8, fin: { hex: '#0FA3B1' },
    eqTags: ['Фильтрация', 'Подогрев', 'Подсветка', 'Лестница', 'Закладные', 'ПВХ плёнка'],
    price: 4415080, grad: ['#0A3B55', '#0A7B86'],
    photo: '/objects/medey.webp', poolType: 'Переливной',
    alt: 'Переливной бассейн 10×5 м — частный дом в районе Медеу, Алматы. Оборудование Welland.',
  },
  {
    name: 'Коттедж · Самал', city: 'Алматы', tag: 'КОТТЕДЖ', span: 1,
    len: 8, wid: 4, dep: 1.6, fin: { hex: '#0A6E8C' },
    eqTags: ['Фильтрация', 'Подсветка', 'Лестница', 'Закладные', 'ПВХ плёнка'],
    price: 2529700, grad: ['#071525', '#0F3B4F'],
    photo: '/objects/samal.webp', poolType: 'Скиммерный',
    alt: 'Скиммерный бассейн 8×4 м — коттедж в районе Самал, Алматы. Оборудование для бассейна Welland.',
  },
  {
    name: 'Коттедж · Кок-Тобе', city: 'Алматы', tag: 'КОТТЕДЖ', span: 1,
    len: 6, wid: 3, dep: 1.4, fin: { hex: '#2A3B44' },
    eqTags: ['Фильтрация', 'Подогрев', 'Подсветка', 'Лестница', 'Закладные', 'Мозаика'],
    price: 3005230, grad: ['#071525', '#0D2D3D'],
    photo: '/objects/kok.webp', poolType: 'Переливной',
    alt: 'Переливной бассейн с мозаикой 6×3 м — коттедж Кок-Тобе, Алматы. Подбор оборудования Welland.',
  },
  {
    name: 'Загородный дом · Каскелен', city: 'Каскелен', tag: 'ЗАГОРОДНЫЙ', span: 2,
    len: 12, wid: 6, dep: 2.0, fin: { hex: '#0A3040' },
    eqTags: ['Фильтрация', 'Подогрев', 'Подсветка', 'Лестница', 'Закладные', 'Мозаика'],
    price: 7435520, grad: ['#040E1A', '#0A4B5A'],
    photo: '/objects/kaskelen.webp', poolType: 'Скиммерный',
    alt: 'Скиммерный бассейн 12×6 м — загородный дом Каскелен, Казахстан. Полный комплект оборудования Welland.',
  },
]

function srcset(photo, span) {
  if (!photo) return undefined
  const base = photo.replace(/\.[^.]+$/, '')
  return span === 2
    ? `${base}-800.webp 800w, ${base}-1600.webp 1600w`
    : `${base}-400.webp 400w, ${base}-800.webp 800w`
}

function GalPoolThumb({ g }) {
  const h = 220
  const bg = `linear-gradient(135deg,${g.grad[0]},${g.grad[1]})`
  const photo2 = g.photo ? g.photo.replace(/(\.[^.]+)$/, '2$1') : null
  const sizes = g.span === 2 ? '(max-width:600px) 100vw, 800px' : '(max-width:600px) 100vw, 400px'
  const imgStyle = { width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }

  return (
    <div
      className="gal-thumb-wrap"
      style={{ height: h, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onMouseEnter={e => {
        if (!g.photo) return
        const p1 = e.currentTarget.querySelector('.gal-p1')
        const p2 = e.currentTarget.querySelector('.gal-p2')
        if (p1) p1.style.opacity = '0'
        if (p2) p2.style.opacity = '1'
      }}
      onMouseLeave={e => {
        if (!g.photo) return
        const p1 = e.currentTarget.querySelector('.gal-p1')
        const p2 = e.currentTarget.querySelector('.gal-p2')
        if (p1) p1.style.opacity = '1'
        if (p2) p2.style.opacity = '0'
      }}
    >
      {g.photo && (
        <div className="gal-p1" style={{ position: 'absolute', inset: 0, transition: 'opacity .4s ease' }}>
          <img src={g.photo} srcSet={srcset(g.photo, g.span)} sizes={sizes} alt={g.alt || g.name} loading="lazy" decoding="async" style={imgStyle}/>
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top,rgba(0,0,0,.28) 0%,transparent 50%)', pointerEvents: 'none' }}/>
        </div>
      )}

      {photo2 && (
        <div className="gal-p2" style={{ position: 'absolute', inset: 0, opacity: 0, transition: 'opacity .4s ease' }}>
          <img src={photo2} srcSet={srcset(photo2, g.span)} sizes={sizes} alt={g.alt || g.name} loading="lazy" decoding="async" style={imgStyle}/>
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top,rgba(0,0,0,.28) 0%,transparent 50%)', pointerEvents: 'none' }}/>
        </div>
      )}

      {/* Tags */}
      <span style={{ position: 'absolute', top: 12, left: 12, fontFamily: "'JetBrains Mono',monospace", fontSize: 10, letterSpacing: '.12em', color: '#eafdff', background: 'rgba(1,8,16,.55)', padding: '5px 9px', borderRadius: 5, backdropFilter: 'blur(4px)', zIndex: 2 }}>{g.tag}</span>
      <span style={{ position: 'absolute', top: 12, right: 12, fontFamily: "'JetBrains Mono',monospace", fontSize: 10, color: 'rgba(200,240,250,.85)', background: 'rgba(1,8,16,.45)', padding: '5px 9px', borderRadius: 5, zIndex: 2 }}>{g.len}×{g.wid}×{g.dep} м</span>
      {g.photo && (
        <span style={{ position: 'absolute', bottom: 12, left: 12, fontFamily: "'JetBrains Mono',monospace", fontSize: 9, letterSpacing: '.1em', color: '#eafdff', background: 'rgba(15,163,177,.6)', padding: '4px 8px', borderRadius: 4, backdropFilter: 'blur(4px)', zIndex: 2 }}>ФОТО</span>
      )}

    </div>
  )
}

export default function Gallery() {
  return (
    <section className="sec" id="gallery" style={{ background: C.paper }}>
      <div className="wrap">
        <Fade className="sec-head">
          <span className="eb light">РЕАЛИЗОВАННЫЕ ОБЪЕКТЫ</span>
          <h2 className="chrome-ink" style={{ fontSize: 'clamp(26px,3.5vw,42px)', marginTop: 16 }}>Проекты наших клиентов</h2>
          <p style={{ color: C.ink2, fontSize: 16.5, lineHeight: 1.65, marginTop: 14, maxWidth: 480, margin: '14px auto 0' }}>
            Клиенты подобрали комплект через наш сервис - и получили готовые бассейны с профессиональным оборудованием.
          </p>
        </Fade>
        <div className="gal-grid">
          {GALS.map((g, i) => (
            <Fade key={g.name} delay={i * 70} className={g.span === 2 ? 'gal-span2' : undefined} style={{ height: '100%' }}>
              <div
                className="card-l"
                style={{ overflow: 'hidden', transition: 'box-shadow .25s,border-color .25s', height: '100%', display: 'flex', flexDirection: 'column' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 14px 44px rgba(6,32,46,.18)'; e.currentTarget.style.borderColor = 'rgba(10,123,134,.22)' }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.borderColor = '' }}
              >
                <GalPoolThumb g={g}/>
                <div style={{ padding: '16px 20px 18px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                    <div style={{ fontWeight: 800, fontSize: 16, color: C.ink }}>{g.name}</div>
                    {g.poolType && (
                      <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.06em', color: g.poolType === 'Переливной' ? '#0891b2' : '#b45309', background: g.poolType === 'Переливной' ? 'rgba(8,145,178,.13)' : 'rgba(180,83,9,.11)', border: `1.5px solid ${g.poolType === 'Переливной' ? 'rgba(8,145,178,.45)' : 'rgba(180,83,9,.4)'}`, borderRadius: 999, padding: '3px 10px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                        {g.poolType}
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 8 }}>
                    {g.eqTags.map(t => (
                      <span key={t} style={{ fontSize: 11, fontWeight: 600, color: '#0A7B86', background: 'rgba(10,123,134,.08)', border: '1px solid rgba(10,123,134,.18)', borderRadius: 999, padding: '3px 8px' }}>{t}</span>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                    <span style={{ fontSize: 13, color: C.muted, display: 'flex', alignItems: 'center', gap: 4 }}><Ic n="pin" s={12}/>{g.city}</span>
                    <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, fontWeight: 700, color: '#0A7B86' }}>{fmt(g.price)} ₸</span>
                  </div>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  )
}
